<template>
  <div class="mb-3">
    <label class="d-block"
      >{{ label }} <span v-if="required" class="text-danger">*</span></label
    >
    <vee-field
      :name="name"
      :rules="validationRules"
      v-slot="{ field, handleChange, meta }"
    >
      <div>
        <div v-for="option in options" :key="option.value" class="form-check">
          <input
            type="checkbox"
            :id="`${id}_${option.value}`"
            :value="option.value"
            v-model="selectedValues"
            class="form-check-input"
            @change="updateField(handleChange)"
          />
          <label class="form-check-label" :for="`${id}_${option.value}`">
            {{ option.key }}
          </label>
        </div>
      </div>
    </vee-field>
    <ErrorMessage class="text-danger" :name="name" />
  </div>
</template>

<script setup>
import { ref, watch } from "vue";

const selectedValues = ref([]);

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  options: {
    type: Array,
    default: () => [],
  },
  fieldName: {
    type: String,
    default: "",
  },
  validationRules: {
    type: [Function, Array, String, Object],
    default: () => () => true,
  },
});

function updateField(handleChange) {
  handleChange([...selectedValues.value]);
}
</script>
